import { useRef } from "react";
import Hero from "../components/Hero";
import BaseLayout from "../layouts/BaseLayout";

export default function Home() {
  const batRef = useRef(null);

  return (
    <BaseLayout>
      <Hero batRef={batRef} />
    </BaseLayout>
  );
}
